import { pcOrMobile } from '../assets/js/util.js'

if (process.client && process.env.NODE_ENV === 'localhost' && pcOrMobile(navigator.userAgent)) {
  const VConsole = require('vconsole')
  // eslint-disable-next-line no-new
  new VConsole()
}
